import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import {
  IrbSubscriptionDetailsGQL,
  IrbSubscriptionDetailsQuery,
  IrbSubscriptionDetailsType,
} from "../../../../apis/networkdashboard/graphql/graphql";
import { SubscriptionPageComponent } from "../../../../components/subscription-detail/subscription-page/subscription-page";
import { GenericSubscription } from "../generic-subscription";
import { IrbSubscriptionViewComponent } from "./irb-subscription-view";

@Component({
  selector: "irb-subscription",
  templateUrl: "irb-subscription.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IrbSubscriptionViewComponent, SubscriptionPageComponent],
})
export class IrbSubscriptionComponent extends GenericSubscription<
  IrbSubscriptionDetailsQuery,
  IrbSubscriptionDetailsType
> {
  protected query = inject(IrbSubscriptionDetailsGQL);

  protected onQuerySuccess(data: IrbSubscriptionDetailsQuery): IrbSubscriptionDetailsType {
    return data.irbDetails as IrbSubscriptionDetailsType;
  }
}
